/* eslint-disable camelcase, react/jsx-pascal-case, max-len, quote-props */

import { ReactComponent as Component_1_marketplace } from 'src/assets/icons/workspace/app-icons/1_marketplace.svg';
import { ReactComponent as Component_activity_heart } from 'src/assets/icons/workspace/app-icons/activity-heart.svg';
import { ReactComponent as Component_activity } from 'src/assets/icons/workspace/app-icons/activity.svg';
import { ReactComponent as Component_ads_advertisment_promotion_01 } from 'src/assets/icons/workspace/app-icons/ads_advertisment_promotion_01.svg';
import { ReactComponent as Component_alarm_clock } from 'src/assets/icons/workspace/app-icons/alarm-clock.svg';
import { ReactComponent as Component_alert_circle } from 'src/assets/icons/workspace/app-icons/alert-circle.svg';
import { ReactComponent as Component_alert_triangle } from 'src/assets/icons/workspace/app-icons/alert-triangle.svg';
import { ReactComponent as Component_anchor } from 'src/assets/icons/workspace/app-icons/anchor.svg';
import { ReactComponent as Component_annotation_check } from 'src/assets/icons/workspace/app-icons/annotation-check.svg';
import { ReactComponent as Component_announcement_01 } from 'src/assets/icons/workspace/app-icons/announcement-01.svg';
import { ReactComponent as Component_announcement_03 } from 'src/assets/icons/workspace/app-icons/announcement-03.svg';
import { ReactComponent as Component_atom_01 } from 'src/assets/icons/workspace/app-icons/atom-01.svg';
import { ReactComponent as Component_award_01 } from 'src/assets/icons/workspace/app-icons/award-01.svg';
import { ReactComponent as Component_award_05 } from 'src/assets/icons/workspace/app-icons/award-05.svg';
import { ReactComponent as Component_baby_boy_01 } from 'src/assets/icons/workspace/app-icons/baby_boy_01.svg';
import { ReactComponent as Component_baggage_01 } from 'src/assets/icons/workspace/app-icons/baggage_01.svg';
import { ReactComponent as Component_bank_note_03 } from 'src/assets/icons/workspace/app-icons/bank-note-03.svg';
import { ReactComponent as Component_bank_2_01 } from 'src/assets/icons/workspace/app-icons/bank_2_01.svg';
import { ReactComponent as Component_bar_chart_07 } from 'src/assets/icons/workspace/app-icons/bar-chart-07.svg';
import { ReactComponent as Component_bar_chart_square_01 } from 'src/assets/icons/workspace/app-icons/bar-chart-square-01.svg';
import { ReactComponent as Component_bath_bathroom_01 } from 'src/assets/icons/workspace/app-icons/bath_bathroom_01.svg';
import { ReactComponent as Component_beach_umbrella_01 } from 'src/assets/icons/workspace/app-icons/beach_umbrella_01.svg';
import { ReactComponent as Component_bell_01 } from 'src/assets/icons/workspace/app-icons/bell-01.svg';
import { ReactComponent as Component_bell_off_01 } from 'src/assets/icons/workspace/app-icons/bell-off-01.svg';
import { ReactComponent as Component_bluetooth_on } from 'src/assets/icons/workspace/app-icons/bluetooth-on.svg';
import { ReactComponent as Component_book_closed } from 'src/assets/icons/workspace/app-icons/book-closed.svg';
import { ReactComponent as Component_bookmark } from 'src/assets/icons/workspace/app-icons/bookmark.svg';
import { ReactComponent as Component_briefcase_02 } from 'src/assets/icons/workspace/app-icons/briefcase-02.svg';
import { ReactComponent as Component_brightness_photo_edit_1_01 } from 'src/assets/icons/workspace/app-icons/brightness_photo_edit_1_01.svg';
import { ReactComponent as Component_building_04 } from 'src/assets/icons/workspace/app-icons/building-04.svg';
import { ReactComponent as Component_building_06 } from 'src/assets/icons/workspace/app-icons/building-06.svg';
import { ReactComponent as Component_building_08 } from 'src/assets/icons/workspace/app-icons/building-08.svg';
import { ReactComponent as Component_burger_copy_01 } from 'src/assets/icons/workspace/app-icons/burger_copy_01.svg';
import { ReactComponent as Component_bus } from 'src/assets/icons/workspace/app-icons/bus.svg';
import { ReactComponent as Component_cake_01 } from 'src/assets/icons/workspace/app-icons/cake_01.svg';
import { ReactComponent as Component_calendar_check_01 } from 'src/assets/icons/workspace/app-icons/calendar-check-01.svg';
import { ReactComponent as Component_calendar_heart_01 } from 'src/assets/icons/workspace/app-icons/calendar-heart-01.svg';
import { ReactComponent as Component_calendar } from 'src/assets/icons/workspace/app-icons/calendar.svg';
import { ReactComponent as Component_camera_01 } from 'src/assets/icons/workspace/app-icons/camera-01.svg';
import { ReactComponent as Component_car_01 } from 'src/assets/icons/workspace/app-icons/car-01.svg';
import { ReactComponent as Component_certificate_02 } from 'src/assets/icons/workspace/app-icons/certificate-02.svg';
import { ReactComponent as Component_check_circle } from 'src/assets/icons/workspace/app-icons/check-circle.svg';
import { ReactComponent as Component_check } from 'src/assets/icons/workspace/app-icons/check.svg';
import { ReactComponent as Component_clapperboard } from 'src/assets/icons/workspace/app-icons/clapperboard.svg';
import { ReactComponent as Component_clock_fast_forward } from 'src/assets/icons/workspace/app-icons/clock-fast-forward.svg';
import { ReactComponent as Component_clock_stopwatch } from 'src/assets/icons/workspace/app-icons/clock-stopwatch.svg';
import { ReactComponent as Component_clock } from 'src/assets/icons/workspace/app-icons/clock.svg';
import { ReactComponent as Component_cloud_01 } from 'src/assets/icons/workspace/app-icons/cloud-01.svg';
import { ReactComponent as Component_cloud_raining_01 } from 'src/assets/icons/workspace/app-icons/cloud-raining-01.svg';
import { ReactComponent as Component_cloud_sun_01 } from 'src/assets/icons/workspace/app-icons/cloud-sun-01.svg';
import { ReactComponent as Component_code_02 } from 'src/assets/icons/workspace/app-icons/code-02.svg';
import { ReactComponent as Component_code_circle_01 } from 'src/assets/icons/workspace/app-icons/code-circle-01.svg';
import { ReactComponent as Component_coins_01 } from 'src/assets/icons/workspace/app-icons/coins-01.svg';
import { ReactComponent as Component_coins_hand } from 'src/assets/icons/workspace/app-icons/coins-hand.svg';
import { ReactComponent as Component_coins_stacked_03 } from 'src/assets/icons/workspace/app-icons/coins-stacked-03.svg';
import { ReactComponent as Component_compass_03 } from 'src/assets/icons/workspace/app-icons/compass-03.svg';
import { ReactComponent as Component_compuer_employee_01 } from 'src/assets/icons/workspace/app-icons/compuer_employee_01.svg';
import { ReactComponent as Component_computer_01 } from 'src/assets/icons/workspace/app-icons/computer_01.svg';
import { ReactComponent as Component_copy_01 } from 'src/assets/icons/workspace/app-icons/copy-01.svg';
import { ReactComponent as Component_credit_card_01 } from 'src/assets/icons/workspace/app-icons/credit-card-01.svg';
import { ReactComponent as Component_croissant_01 } from 'src/assets/icons/workspace/app-icons/croissant_01.svg';
import { ReactComponent as Component_currency_bitcoin_circle } from 'src/assets/icons/workspace/app-icons/currency-bitcoin-circle.svg';
import { ReactComponent as Component_currency_dollar } from 'src/assets/icons/workspace/app-icons/currency-dollar.svg';
import { ReactComponent as Component_currency_euro_circle } from 'src/assets/icons/workspace/app-icons/currency-euro-circle.svg';
import { ReactComponent as Component_currency_euro } from 'src/assets/icons/workspace/app-icons/currency-euro.svg';
import { ReactComponent as Component_currency_pound_circle } from 'src/assets/icons/workspace/app-icons/currency-pound-circle.svg';
import { ReactComponent as Component_currency_pound } from 'src/assets/icons/workspace/app-icons/currency-pound.svg';
import { ReactComponent as Component_currency_yen_circle } from 'src/assets/icons/workspace/app-icons/currency-yen-circle.svg';
import { ReactComponent as Component_cutlery } from 'src/assets/icons/workspace/app-icons/cutlery.svg';
import { ReactComponent as Component_dashboard_1_2_01 } from 'src/assets/icons/workspace/app-icons/dashboard_1_2_01.svg';
import { ReactComponent as Component_dataflow_01 } from 'src/assets/icons/workspace/app-icons/dataflow-01.svg';
import { ReactComponent as Component_dataflow_04 } from 'src/assets/icons/workspace/app-icons/dataflow-04.svg';
import { ReactComponent as Component_desktop_computer_pc_01 } from 'src/assets/icons/workspace/app-icons/desktop_computer_pc_01.svg';
import { ReactComponent as Component_diamond_01 } from 'src/assets/icons/workspace/app-icons/diamond-01.svg';
import { ReactComponent as Component_doctor_01 } from 'src/assets/icons/workspace/app-icons/doctor_01.svg';
import { ReactComponent as Component_document_content_16_01 } from 'src/assets/icons/workspace/app-icons/document_content_16_01.svg';
import { ReactComponent as Component_double_bed_01 } from 'src/assets/icons/workspace/app-icons/double_bed_01.svg';
import { ReactComponent as Component_droplets_01 } from 'src/assets/icons/workspace/app-icons/droplets-01.svg';
import { ReactComponent as Component_edit_02 } from 'src/assets/icons/workspace/app-icons/edit-02.svg';
import { ReactComponent as Component_face_id } from 'src/assets/icons/workspace/app-icons/face-id.svg';
import { ReactComponent as Component_file_05 } from 'src/assets/icons/workspace/app-icons/file-05.svg';
import { ReactComponent as Component_file_07 } from 'src/assets/icons/workspace/app-icons/file-07.svg';
import { ReactComponent as Component_file_attachment_04 } from 'src/assets/icons/workspace/app-icons/file-attachment-04.svg';
import { ReactComponent as Component_file_check_02 } from 'src/assets/icons/workspace/app-icons/file-check-02.svg';
import { ReactComponent as Component_file_download_03 } from 'src/assets/icons/workspace/app-icons/file-download-03.svg';
import { ReactComponent as Component_file_heart_02 } from 'src/assets/icons/workspace/app-icons/file-heart-02.svg';
import { ReactComponent as Component_file_search_02 } from 'src/assets/icons/workspace/app-icons/file-search-02.svg';
import { ReactComponent as Component_film_02 } from 'src/assets/icons/workspace/app-icons/film-02.svg';
import { ReactComponent as Component_fingerprint_02 } from 'src/assets/icons/workspace/app-icons/fingerprint-02.svg';
import { ReactComponent as Component_fire } from 'src/assets/icons/workspace/app-icons/fire.svg';
import { ReactComponent as Component_flag_02 } from 'src/assets/icons/workspace/app-icons/flag-02.svg';
import { ReactComponent as Component_folder_check } from 'src/assets/icons/workspace/app-icons/folder-check.svg';
import { ReactComponent as Component_folder_plus } from 'src/assets/icons/workspace/app-icons/folder-plus.svg';
import { ReactComponent as Component_fork_knife_01 } from 'src/assets/icons/workspace/app-icons/fork_knife_01.svg';
import { ReactComponent as Component_gift_01 } from 'src/assets/icons/workspace/app-icons/gift-01.svg';
import { ReactComponent as Component_glasses_02 } from 'src/assets/icons/workspace/app-icons/glasses-02.svg';
import { ReactComponent as Component_globe_02 } from 'src/assets/icons/workspace/app-icons/globe-02.svg';
import { ReactComponent as Component_globe_04 } from 'src/assets/icons/workspace/app-icons/globe-04.svg';
import { ReactComponent as Component_globe_05 } from 'src/assets/icons/workspace/app-icons/globe-05.svg';
import { ReactComponent as Component_graduation_hat_02 } from 'src/assets/icons/workspace/app-icons/graduation-hat-02.svg';
import { ReactComponent as Component_headphones_01 } from 'src/assets/icons/workspace/app-icons/headphones-01.svg';
import { ReactComponent as Component_heart_hand } from 'src/assets/icons/workspace/app-icons/heart-hand.svg';
import { ReactComponent as Component_heart } from 'src/assets/icons/workspace/app-icons/heart.svg';
import { ReactComponent as Component_hearts } from 'src/assets/icons/workspace/app-icons/hearts.svg';
import { ReactComponent as Component_help_circle } from 'src/assets/icons/workspace/app-icons/help-circle.svg';
import { ReactComponent as Component_home_03 } from 'src/assets/icons/workspace/app-icons/home-03.svg';
import { ReactComponent as Component_hourglass_01 } from 'src/assets/icons/workspace/app-icons/hourglass-01.svg';
import { ReactComponent as Component_image_01 } from 'src/assets/icons/workspace/app-icons/image-01.svg';
import { ReactComponent as Component_image_05 } from 'src/assets/icons/workspace/app-icons/image-05.svg';
import { ReactComponent as Component_image_user } from 'src/assets/icons/workspace/app-icons/image-user.svg';
import { ReactComponent as Component_inbox_01 } from 'src/assets/icons/workspace/app-icons/inbox-01.svg';
import { ReactComponent as Component_key_01 } from 'src/assets/icons/workspace/app-icons/key-01.svg';
import { ReactComponent as Component_laptop_01 } from 'src/assets/icons/workspace/app-icons/laptop-01.svg';
import { ReactComponent as Component_life_buoy_01 } from 'src/assets/icons/workspace/app-icons/life-buoy-01.svg';
import { ReactComponent as Component_lightbulb_02 } from 'src/assets/icons/workspace/app-icons/lightbulb-02.svg';
import { ReactComponent as Component_line_chart_up_01 } from 'src/assets/icons/workspace/app-icons/line-chart-up-01.svg';
import { ReactComponent as Component_link_03 } from 'src/assets/icons/workspace/app-icons/link-03.svg';
import { ReactComponent as Component_lock_01 } from 'src/assets/icons/workspace/app-icons/lock-01.svg';
import { ReactComponent as Component_lock_04 } from 'src/assets/icons/workspace/app-icons/lock-04.svg';
import { ReactComponent as Component_magic_wand_2_01 } from 'src/assets/icons/workspace/app-icons/magic_wand_2_01.svg';
import { ReactComponent as Component_mail_01 } from 'src/assets/icons/workspace/app-icons/mail-01.svg';
import { ReactComponent as Component_map_01 } from 'src/assets/icons/workspace/app-icons/map-01.svg';
import { ReactComponent as Component_map_location_search_01 } from 'src/assets/icons/workspace/app-icons/map_location_search_01.svg';
import { ReactComponent as Component_mark } from 'src/assets/icons/workspace/app-icons/mark.svg';
import { ReactComponent as Component_marker_pin_01 } from 'src/assets/icons/workspace/app-icons/marker-pin-01.svg';
import { ReactComponent as Component_marker_pin_04 } from 'src/assets/icons/workspace/app-icons/marker-pin-04.svg';
import { ReactComponent as Component_medal_prize_reward_1_01 } from 'src/assets/icons/workspace/app-icons/medal_prize_reward_1_01.svg';
import { ReactComponent as Component_medical_cross } from 'src/assets/icons/workspace/app-icons/medical-cross.svg';
import { ReactComponent as Component_message_chat_circle } from 'src/assets/icons/workspace/app-icons/message-chat-circle.svg';
import { ReactComponent as Component_message_text_circle_01 } from 'src/assets/icons/workspace/app-icons/message-text-circle-01.svg';
import { ReactComponent as Component_microphone_01 } from 'src/assets/icons/workspace/app-icons/microphone-01.svg';
import { ReactComponent as Component_modem_02 } from 'src/assets/icons/workspace/app-icons/modem-02.svg';
import { ReactComponent as Component_money_01 } from 'src/assets/icons/workspace/app-icons/money_01.svg';
import { ReactComponent as Component_money_coins_1_01 } from 'src/assets/icons/workspace/app-icons/money_coins_1_01.svg';
import { ReactComponent as Component_monitor_01 } from 'src/assets/icons/workspace/app-icons/monitor-01.svg';
import { ReactComponent as Component_monitor_05 } from 'src/assets/icons/workspace/app-icons/monitor-05.svg';
import { ReactComponent as Component_moon_02 } from 'src/assets/icons/workspace/app-icons/moon-02.svg';
import { ReactComponent as Component_music_note_01 } from 'src/assets/icons/workspace/app-icons/music-note-01.svg';
import { ReactComponent as Component_navigation_pointer_01 } from 'src/assets/icons/workspace/app-icons/navigation-pointer-01.svg';
import { ReactComponent as Component_notebook_notepad_1_01 } from 'src/assets/icons/workspace/app-icons/notebook_notepad_1_01.svg';
import { ReactComponent as Component_pencil_ruler_grid_01 } from 'src/assets/icons/workspace/app-icons/pencil_ruler_grid_01.svg';
import { ReactComponent as Component_phone_call_01 } from 'src/assets/icons/workspace/app-icons/phone-call-01.svg';
import { ReactComponent as Component_pie_chart_02 } from 'src/assets/icons/workspace/app-icons/pie-chart-02.svg';
import { ReactComponent as Component_piggy_bank_01 } from 'src/assets/icons/workspace/app-icons/piggy-bank-01.svg';
import { ReactComponent as Component_pin_01 } from 'src/assets/icons/workspace/app-icons/pin-01.svg';
import { ReactComponent as Component_pin_02 } from 'src/assets/icons/workspace/app-icons/pin-02.svg';
import { ReactComponent as Component_plane } from 'src/assets/icons/workspace/app-icons/plane.svg';
import { ReactComponent as Component_play } from 'src/assets/icons/workspace/app-icons/play.svg';
import { ReactComponent as Component_power_01 } from 'src/assets/icons/workspace/app-icons/power-01.svg';
import { ReactComponent as Component_presentation_chart_02 } from 'src/assets/icons/workspace/app-icons/presentation-chart-02.svg';
import { ReactComponent as Component_question_3_circle_01 } from 'src/assets/icons/workspace/app-icons/question_3_circle_01.svg';
import { ReactComponent as Component_rocket_01 } from 'src/assets/icons/workspace/app-icons/rocket-01.svg';
import { ReactComponent as Component_rocket_02 } from 'src/assets/icons/workspace/app-icons/rocket-02.svg';
import { ReactComponent as Component_room_service_clean_1_01 } from 'src/assets/icons/workspace/app-icons/room_service_clean_1_01.svg';
import { ReactComponent as Component_route } from 'src/assets/icons/workspace/app-icons/route.svg';
import { ReactComponent as Component_sale_02 } from 'src/assets/icons/workspace/app-icons/sale-02.svg';
import { ReactComponent as Component_save_01 } from 'src/assets/icons/workspace/app-icons/save-01.svg';
import { ReactComponent as Component_scales_01 } from 'src/assets/icons/workspace/app-icons/scales-01.svg';
import { ReactComponent as Component_scales_02 } from 'src/assets/icons/workspace/app-icons/scales-02.svg';
import { ReactComponent as Component_search_refraction } from 'src/assets/icons/workspace/app-icons/search-refraction.svg';
import { ReactComponent as Component_send_01 } from 'src/assets/icons/workspace/app-icons/send-01.svg';
import { ReactComponent as Component_server_03 } from 'src/assets/icons/workspace/app-icons/server-03.svg';
import { ReactComponent as Component_server_05 } from 'src/assets/icons/workspace/app-icons/server-05.svg';
import { ReactComponent as Component_settings_01 } from 'src/assets/icons/workspace/app-icons/settings-01.svg';
import { ReactComponent as Component_share_06 } from 'src/assets/icons/workspace/app-icons/share-06.svg';
import { ReactComponent as Component_share_07 } from 'src/assets/icons/workspace/app-icons/share-07.svg';
import { ReactComponent as Component_shield_01 } from 'src/assets/icons/workspace/app-icons/shield-01.svg';
import { ReactComponent as Component_shield_tick } from 'src/assets/icons/workspace/app-icons/shield-tick.svg';
import { ReactComponent as Component_shopping_cart_01 } from 'src/assets/icons/workspace/app-icons/shopping-cart-01.svg';
import { ReactComponent as Component_shuttlecock_volant_01 } from 'src/assets/icons/workspace/app-icons/shuttlecock_volant_01.svg';
import { ReactComponent as Component_sliders_01 } from 'src/assets/icons/workspace/app-icons/sliders-01.svg';
import { ReactComponent as Component_sliders_04 } from 'src/assets/icons/workspace/app-icons/sliders-04.svg';
import { ReactComponent as Component_sneakers_01 } from 'src/assets/icons/workspace/app-icons/sneakers_01.svg';
import { ReactComponent as Component_snowflake_01 } from 'src/assets/icons/workspace/app-icons/snowflake-01.svg';
import { ReactComponent as Component_snowflake_02 } from 'src/assets/icons/workspace/app-icons/snowflake-02.svg';
import { ReactComponent as Component_speaker_01 } from 'src/assets/icons/workspace/app-icons/speaker-01.svg';
import { ReactComponent as Component_speedometer_02 } from 'src/assets/icons/workspace/app-icons/speedometer-02.svg';
import { ReactComponent as Component_stars_01 } from 'src/assets/icons/workspace/app-icons/stars-01.svg';
import { ReactComponent as Component_store_01 } from 'src/assets/icons/workspace/app-icons/store_01.svg';
import { ReactComponent as Component_sun_setting_01 } from 'src/assets/icons/workspace/app-icons/sun-setting-01.svg';
import { ReactComponent as Component_sun } from 'src/assets/icons/workspace/app-icons/sun.svg';
import { ReactComponent as Component_tag_01 } from 'src/assets/icons/workspace/app-icons/tag-01.svg';
import { ReactComponent as Component_target_03 } from 'src/assets/icons/workspace/app-icons/target-03.svg';
import { ReactComponent as Component_target_04 } from 'src/assets/icons/workspace/app-icons/target-04.svg';
import { ReactComponent as Component_telescope } from 'src/assets/icons/workspace/app-icons/telescope.svg';
import { ReactComponent as Component_thermometer_03 } from 'src/assets/icons/workspace/app-icons/thermometer-03.svg';
import { ReactComponent as Component_ticket_01 } from 'src/assets/icons/workspace/app-icons/ticket-01.svg';
import { ReactComponent as Component_tool_01 } from 'src/assets/icons/workspace/app-icons/tool-01.svg';
import { ReactComponent as Component_train } from 'src/assets/icons/workspace/app-icons/train.svg';
import { ReactComponent as Component_trash_03 } from 'src/assets/icons/workspace/app-icons/trash-03.svg';
import { ReactComponent as Component_trolley_01 } from 'src/assets/icons/workspace/app-icons/trolley_01.svg';
import { ReactComponent as Component_trolleybus_01 } from 'src/assets/icons/workspace/app-icons/trolleybus_01.svg';
import { ReactComponent as Component_trophy_01 } from 'src/assets/icons/workspace/app-icons/trophy-01.svg';
import { ReactComponent as Component_truck_01 } from 'src/assets/icons/workspace/app-icons/truck-01.svg';
import { ReactComponent as Component_tv_01 } from 'src/assets/icons/workspace/app-icons/tv-01.svg';
import { ReactComponent as Component_tv_03 } from 'src/assets/icons/workspace/app-icons/tv-03.svg';
import { ReactComponent as Component_umbrella_02 } from 'src/assets/icons/workspace/app-icons/umbrella-02.svg';
import { ReactComponent as Component_umbrella_03 } from 'src/assets/icons/workspace/app-icons/umbrella-03.svg';
import { ReactComponent as Component_usb_flash_drive } from 'src/assets/icons/workspace/app-icons/usb-flash-drive.svg';
import { ReactComponent as Component_user_01 } from 'src/assets/icons/workspace/app-icons/user-01.svg';
import { ReactComponent as Component_user_check_01 } from 'src/assets/icons/workspace/app-icons/user-check-01.svg';
import { ReactComponent as Component_user_circle } from 'src/assets/icons/workspace/app-icons/user-circle.svg';
import { ReactComponent as Component_user_down_02 } from 'src/assets/icons/workspace/app-icons/user-down-02.svg';
import { ReactComponent as Component_users_01 } from 'src/assets/icons/workspace/app-icons/users-01.svg';
import { ReactComponent as Component_users_right } from 'src/assets/icons/workspace/app-icons/users-right.svg';
import { ReactComponent as Component_virus } from 'src/assets/icons/workspace/app-icons/virus.svg';
import { ReactComponent as Component_volume_max } from 'src/assets/icons/workspace/app-icons/volume-max.svg';
import { ReactComponent as Component_wallet_02 } from 'src/assets/icons/workspace/app-icons/wallet-02.svg';
import { ReactComponent as Component_webcam_01 } from 'src/assets/icons/workspace/app-icons/webcam-01.svg';
import { ReactComponent as Component_wifi } from 'src/assets/icons/workspace/app-icons/wifi.svg';
import { ReactComponent as Component_wind_02 } from 'src/assets/icons/workspace/app-icons/wind-02.svg';
import { ReactComponent as Component_youtube } from 'src/assets/icons/workspace/app-icons/youtube.svg';
import { ReactComponent as Component_zap_square } from 'src/assets/icons/workspace/app-icons/zap-square.svg';
import { ReactComponent as Component_zap } from 'src/assets/icons/workspace/app-icons/zap.svg';

export const APP_ICONS_NAMES = [
  '1_marketplace',
  'activity-heart',
  'activity',
  'ads_advertisment_promotion_01',
  'alarm-clock',
  'alert-circle',
  'alert-triangle',
  'anchor',
  'annotation-check',
  'announcement-01',
  'announcement-03',
  'atom-01',
  'award-01',
  'award-05',
  'baby_boy_01',
  'baggage_01',
  'bank-note-03',
  'bank_2_01',
  'bar-chart-07',
  'bar-chart-square-01',
  'bath_bathroom_01',
  'beach_umbrella_01',
  'bell-01',
  'bell-off-01',
  'bluetooth-on',
  'book-closed',
  'bookmark',
  'briefcase-02',
  'brightness_photo_edit_1_01',
  'building-04',
  'building-06',
  'building-08',
  'burger_copy_01',
  'bus',
  'cake_01',
  'calendar-check-01',
  'calendar-heart-01',
  'calendar',
  'camera-01',
  'car-01',
  'certificate-02',
  'check-circle',
  'check',
  'clapperboard',
  'clock-fast-forward',
  'clock-stopwatch',
  'clock',
  'cloud-01',
  'cloud-raining-01',
  'cloud-sun-01',
  'code-02',
  'code-circle-01',
  'coins-01',
  'coins-hand',
  'coins-stacked-03',
  'compass-03',
  'compuer_employee_01',
  'computer_01',
  'copy-01',
  'credit-card-01',
  'croissant_01',
  'currency-bitcoin-circle',
  'currency-dollar',
  'currency-euro-circle',
  'currency-euro',
  'currency-pound-circle',
  'currency-pound',
  'currency-yen-circle',
  'cutlery',
  'dashboard_1_2_01',
  'dataflow-01',
  'dataflow-04',
  'desktop_computer_pc_01',
  'diamond-01',
  'doctor_01',
  'document_content_16_01',
  'double_bed_01',
  'droplets-01',
  'edit-02',
  'face-id',
  'file-05',
  'file-07',
  'file-attachment-04',
  'file-check-02',
  'file-download-03',
  'file-heart-02',
  'file-search-02',
  'film-02',
  'fingerprint-02',
  'fire',
  'flag-02',
  'folder-check',
  'folder-plus',
  'fork_knife_01',
  'gift-01',
  'glasses-02',
  'globe-02',
  'globe-04',
  'globe-05',
  'graduation-hat-02',
  'headphones-01',
  'heart-hand',
  'heart',
  'hearts',
  'help-circle',
  'home-03',
  'hourglass-01',
  'image-01',
  'image-05',
  'image-user',
  'inbox-01',
  'key-01',
  'laptop-01',
  'life-buoy-01',
  'lightbulb-02',
  'line-chart-up-01',
  'link-03',
  'lock-01',
  'lock-04',
  'magic_wand_2_01',
  'mail-01',
  'map-01',
  'map_location_search_01',
  'mark',
  'marker-pin-01',
  'marker-pin-04',
  'medal_prize_reward_1_01',
  'medical-cross',
  'message-chat-circle',
  'message-text-circle-01',
  'microphone-01',
  'modem-02',
  'money_01',
  'money_coins_1_01',
  'monitor-01',
  'monitor-05',
  'moon-02',
  'music-note-01',
  'navigation-pointer-01',
  'notebook_notepad_1_01',
  'pencil_ruler_grid_01',
  'phone-call-01',
  'pie-chart-02',
  'piggy-bank-01',
  'pin-01',
  'pin-02',
  'plane',
  'play',
  'power-01',
  'presentation-chart-02',
  'question_3_circle_01',
  'rocket-01',
  'rocket-02',
  'room_service_clean_1_01',
  'route',
  'sale-02',
  'save-01',
  'scales-01',
  'scales-02',
  'search-refraction',
  'send-01',
  'server-03',
  'server-05',
  'settings-01',
  'share-06',
  'share-07',
  'shield-01',
  'shield-tick',
  'shopping-cart-01',
  'shuttlecock_volant_01',
  'sliders-01',
  'sliders-04',
  'sneakers_01',
  'snowflake-01',
  'snowflake-02',
  'speaker-01',
  'speedometer-02',
  'stars-01',
  'store_01',
  'sun-setting-01',
  'sun',
  'tag-01',
  'target-03',
  'target-04',
  'telescope',
  'thermometer-03',
  'ticket-01',
  'tool-01',
  'train',
  'trash-03',
  'trolley_01',
  'trolleybus_01',
  'trophy-01',
  'truck-01',
  'tv-01',
  'tv-03',
  'umbrella-02',
  'umbrella-03',
  'usb-flash-drive',
  'user-01',
  'user-check-01',
  'user-circle',
  'user-down-02',
  'users-01',
  'users-right',
  'virus',
  'volume-max',
  'wallet-02',
  'webcam-01',
  'wifi',
  'wind-02',
  'youtube',
  'zap-square',
  'zap',
];

export const ICON_SVG_MAP = {
  '1_marketplace': <Component_1_marketplace />,
  'activity-heart': <Component_activity_heart />,
  'activity': <Component_activity />,
  'ads_advertisment_promotion_01': <Component_ads_advertisment_promotion_01 />,
  'alarm-clock': <Component_alarm_clock />,
  'alert-circle': <Component_alert_circle />,
  'alert-triangle': <Component_alert_triangle />,
  'anchor': <Component_anchor />,
  'annotation-check': <Component_annotation_check />,
  'announcement-01': <Component_announcement_01 />,
  'announcement-03': <Component_announcement_03 />,
  'atom-01': <Component_atom_01 />,
  'award-01': <Component_award_01 />,
  'award-05': <Component_award_05 />,
  'baby_boy_01': <Component_baby_boy_01 />,
  'baggage_01': <Component_baggage_01 />,
  'bank-note-03': <Component_bank_note_03 />,
  'bank_2_01': <Component_bank_2_01 />,
  'bar-chart-07': <Component_bar_chart_07 />,
  'bar-chart-square-01': <Component_bar_chart_square_01 />,
  'bath_bathroom_01': <Component_bath_bathroom_01 />,
  'beach_umbrella_01': <Component_beach_umbrella_01 />,
  'bell-01': <Component_bell_01 />,
  'bell-off-01': <Component_bell_off_01 />,
  'bluetooth-on': <Component_bluetooth_on />,
  'book-closed': <Component_book_closed />,
  'bookmark': <Component_bookmark />,
  'briefcase-02': <Component_briefcase_02 />,
  'brightness_photo_edit_1_01': <Component_brightness_photo_edit_1_01 />,
  'building-04': <Component_building_04 />,
  'building-06': <Component_building_06 />,
  'building-08': <Component_building_08 />,
  'burger_copy_01': <Component_burger_copy_01 />,
  'bus': <Component_bus />,
  'cake_01': <Component_cake_01 />,
  'calendar-check-01': <Component_calendar_check_01 />,
  'calendar-heart-01': <Component_calendar_heart_01 />,
  'calendar': <Component_calendar />,
  'camera-01': <Component_camera_01 />,
  'car-01': <Component_car_01 />,
  'certificate-02': <Component_certificate_02 />,
  'check-circle': <Component_check_circle />,
  'check': <Component_check />,
  'clapperboard': <Component_clapperboard />,
  'clock-fast-forward': <Component_clock_fast_forward />,
  'clock-stopwatch': <Component_clock_stopwatch />,
  'clock': <Component_clock />,
  'cloud-01': <Component_cloud_01 />,
  'cloud-raining-01': <Component_cloud_raining_01 />,
  'cloud-sun-01': <Component_cloud_sun_01 />,
  'code-02': <Component_code_02 />,
  'code-circle-01': <Component_code_circle_01 />,
  'coins-01': <Component_coins_01 />,
  'coins-hand': <Component_coins_hand />,
  'coins-stacked-03': <Component_coins_stacked_03 />,
  'compass-03': <Component_compass_03 />,
  'compuer_employee_01': <Component_compuer_employee_01 />,
  'computer_01': <Component_computer_01 />,
  'copy-01': <Component_copy_01 />,
  'credit-card-01': <Component_credit_card_01 />,
  'croissant_01': <Component_croissant_01 />,
  'currency-bitcoin-circle': <Component_currency_bitcoin_circle />,
  'currency-dollar': <Component_currency_dollar />,
  'currency-euro-circle': <Component_currency_euro_circle />,
  'currency-euro': <Component_currency_euro />,
  'currency-pound-circle': <Component_currency_pound_circle />,
  'currency-pound': <Component_currency_pound />,
  'currency-yen-circle': <Component_currency_yen_circle />,
  'cutlery': <Component_cutlery />,
  'dashboard_1_2_01': <Component_dashboard_1_2_01 />,
  'dataflow-01': <Component_dataflow_01 />,
  'dataflow-04': <Component_dataflow_04 />,
  'desktop_computer_pc_01': <Component_desktop_computer_pc_01 />,
  'diamond-01': <Component_diamond_01 />,
  'doctor_01': <Component_doctor_01 />,
  'document_content_16_01': <Component_document_content_16_01 />,
  'double_bed_01': <Component_double_bed_01 />,
  'droplets-01': <Component_droplets_01 />,
  'edit-02': <Component_edit_02 />,
  'face-id': <Component_face_id />,
  'file-05': <Component_file_05 />,
  'file-07': <Component_file_07 />,
  'file-attachment-04': <Component_file_attachment_04 />,
  'file-check-02': <Component_file_check_02 />,
  'file-download-03': <Component_file_download_03 />,
  'file-heart-02': <Component_file_heart_02 />,
  'file-search-02': <Component_file_search_02 />,
  'film-02': <Component_film_02 />,
  'fingerprint-02': <Component_fingerprint_02 />,
  'fire': <Component_fire />,
  'flag-02': <Component_flag_02 />,
  'folder-check': <Component_folder_check />,
  'folder-plus': <Component_folder_plus />,
  'fork_knife_01': <Component_fork_knife_01 />,
  'gift-01': <Component_gift_01 />,
  'glasses-02': <Component_glasses_02 />,
  'globe-02': <Component_globe_02 />,
  'globe-04': <Component_globe_04 />,
  'globe-05': <Component_globe_05 />,
  'graduation-hat-02': <Component_graduation_hat_02 />,
  'headphones-01': <Component_headphones_01 />,
  'heart-hand': <Component_heart_hand />,
  'heart': <Component_heart />,
  'hearts': <Component_hearts />,
  'help-circle': <Component_help_circle />,
  'home-03': <Component_home_03 />,
  'hourglass-01': <Component_hourglass_01 />,
  'image-01': <Component_image_01 />,
  'image-05': <Component_image_05 />,
  'image-user': <Component_image_user />,
  'inbox-01': <Component_inbox_01 />,
  'key-01': <Component_key_01 />,
  'laptop-01': <Component_laptop_01 />,
  'life-buoy-01': <Component_life_buoy_01 />,
  'lightbulb-02': <Component_lightbulb_02 />,
  'line-chart-up-01': <Component_line_chart_up_01 />,
  'link-03': <Component_link_03 />,
  'lock-01': <Component_lock_01 />,
  'lock-04': <Component_lock_04 />,
  'magic_wand_2_01': <Component_magic_wand_2_01 />,
  'mail-01': <Component_mail_01 />,
  'map-01': <Component_map_01 />,
  'map_location_search_01': <Component_map_location_search_01 />,
  'mark': <Component_mark />,
  'marker-pin-01': <Component_marker_pin_01 />,
  'marker-pin-04': <Component_marker_pin_04 />,
  'medal_prize_reward_1_01': <Component_medal_prize_reward_1_01 />,
  'medical-cross': <Component_medical_cross />,
  'message-chat-circle': <Component_message_chat_circle />,
  'message-text-circle-01': <Component_message_text_circle_01 />,
  'microphone-01': <Component_microphone_01 />,
  'modem-02': <Component_modem_02 />,
  'money_01': <Component_money_01 />,
  'money_coins_1_01': <Component_money_coins_1_01 />,
  'monitor-01': <Component_monitor_01 />,
  'monitor-05': <Component_monitor_05 />,
  'moon-02': <Component_moon_02 />,
  'music-note-01': <Component_music_note_01 />,
  'navigation-pointer-01': <Component_navigation_pointer_01 />,
  'notebook_notepad_1_01': <Component_notebook_notepad_1_01 />,
  'pencil_ruler_grid_01': <Component_pencil_ruler_grid_01 />,
  'phone-call-01': <Component_phone_call_01 />,
  'pie-chart-02': <Component_pie_chart_02 />,
  'piggy-bank-01': <Component_piggy_bank_01 />,
  'pin-01': <Component_pin_01 />,
  'pin-02': <Component_pin_02 />,
  'plane': <Component_plane />,
  'play': <Component_play />,
  'power-01': <Component_power_01 />,
  'presentation-chart-02': <Component_presentation_chart_02 />,
  'question_3_circle_01': <Component_question_3_circle_01 />,
  'rocket-01': <Component_rocket_01 />,
  'rocket-02': <Component_rocket_02 />,
  'room_service_clean_1_01': <Component_room_service_clean_1_01 />,
  'route': <Component_route />,
  'sale-02': <Component_sale_02 />,
  'save-01': <Component_save_01 />,
  'scales-01': <Component_scales_01 />,
  'scales-02': <Component_scales_02 />,
  'search-refraction': <Component_search_refraction />,
  'send-01': <Component_send_01 />,
  'server-03': <Component_server_03 />,
  'server-05': <Component_server_05 />,
  'settings-01': <Component_settings_01 />,
  'share-06': <Component_share_06 />,
  'share-07': <Component_share_07 />,
  'shield-01': <Component_shield_01 />,
  'shield-tick': <Component_shield_tick />,
  'shopping-cart-01': <Component_shopping_cart_01 />,
  'shuttlecock_volant_01': <Component_shuttlecock_volant_01 />,
  'sliders-01': <Component_sliders_01 />,
  'sliders-04': <Component_sliders_04 />,
  'sneakers_01': <Component_sneakers_01 />,
  'snowflake-01': <Component_snowflake_01 />,
  'snowflake-02': <Component_snowflake_02 />,
  'speaker-01': <Component_speaker_01 />,
  'speedometer-02': <Component_speedometer_02 />,
  'stars-01': <Component_stars_01 />,
  'store_01': <Component_store_01 />,
  'sun-setting-01': <Component_sun_setting_01 />,
  'sun': <Component_sun />,
  'tag-01': <Component_tag_01 />,
  'target-03': <Component_target_03 />,
  'target-04': <Component_target_04 />,
  'telescope': <Component_telescope />,
  'thermometer-03': <Component_thermometer_03 />,
  'ticket-01': <Component_ticket_01 />,
  'tool-01': <Component_tool_01 />,
  'train': <Component_train />,
  'trash-03': <Component_trash_03 />,
  'trolley_01': <Component_trolley_01 />,
  'trolleybus_01': <Component_trolleybus_01 />,
  'trophy-01': <Component_trophy_01 />,
  'truck-01': <Component_truck_01 />,
  'tv-01': <Component_tv_01 />,
  'tv-03': <Component_tv_03 />,
  'umbrella-02': <Component_umbrella_02 />,
  'umbrella-03': <Component_umbrella_03 />,
  'usb-flash-drive': <Component_usb_flash_drive />,
  'user-01': <Component_user_01 />,
  'user-check-01': <Component_user_check_01 />,
  'user-circle': <Component_user_circle />,
  'user-down-02': <Component_user_down_02 />,
  'users-01': <Component_users_01 />,
  'users-right': <Component_users_right />,
  'virus': <Component_virus />,
  'volume-max': <Component_volume_max />,
  'wallet-02': <Component_wallet_02 />,
  'webcam-01': <Component_webcam_01 />,
  'wifi': <Component_wifi />,
  'wind-02': <Component_wind_02 />,
  'youtube': <Component_youtube />,
  'zap-square': <Component_zap_square />,
  'zap': <Component_zap />,
};
